import { api } from "./apiSlice";

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export interface MedicalEstablishment {
  id: string;
  name: string;
  address: string;
  region: string;
  email: string;
  bloodCapacity: number;
  isBloodBank: boolean;
}

export const medicalEstablishmentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllMedicalEstablishments: builder.query<MedicalEstablishment[], void>({
      query: () => "/medical-establishments/all",
      transformResponse: (res: ApiResponse<{ establishments: MedicalEstablishment[] }>) => res.data.establishments,
      providesTags: ["MedicalEstablishments"],
    }),
    getMedicalEstablishmentsByDistrict: builder.query<MedicalEstablishment[], string>({
      query: (district) => `/medical-establishments?district=${encodeURIComponent(district)}`,
      transformResponse: (res: ApiResponse<{ establishments: MedicalEstablishment[] }>) => res.data.establishments,
      providesTags: ["MedicalEstablishments"],
    }),
    getMedicalEstablishmentById: builder.query<MedicalEstablishment, string>({
      query: (id) => `/medical-establishments/${id}`,
      transformResponse: (res: ApiResponse<MedicalEstablishment>) => res.data,
      providesTags: (_r, _e, id) => [{ type: "MedicalEstablishments", id }],
    }),
  }),
});

export const { useGetAllMedicalEstablishmentsQuery, useGetMedicalEstablishmentsByDistrictQuery, useGetMedicalEstablishmentByIdQuery } = medicalEstablishmentsApi;
